import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Heading, SimpleGrid, Flex } from '@chakra-ui/react';
import MonitorCard from '../../components/UI/MonitorCard'; 
import MetricCard from '../../components/UI/MetricCard'; 

const Home = () => {
    const navigate = useNavigate();

    const handleNavigate = (path, status) => {
        if (path) {
            navigate(path);
        }
    };

    return (
        <>
            <Box mb={10}>
                <Heading as="h2" size="lg" color="white" mb={6}>
                    Acesso Rápido
                </Heading>
                <SimpleGrid columns={{ base: 1, md: 2, xl: 4 }} spacing={6}>
                    <Box
                        onClick={() => handleNavigate('/panel/erp', 'Ativo')}
                        cursor="pointer"
                        _hover={{ transform: 'translateY(-2px)', shadow: 'lg' }}
                        transition="transform 0.2s ease-in-out"
                    >
                        <MonitorCard
                            title="Erros ERP"
                            description="Monitore erros críticos e exceções do sistema ERP em tempo real."
                            status="Ativo"
                        />
                    </Box>
                    <Box
                        onClick={() => handleNavigate('/panel/erp/screens', 'Ativo')}
                        cursor="pointer"
                         _hover={{ transform: 'translateY(-2px)', shadow: 'lg' }}
                        transition="transform 0.2s ease-in-out"
                    >
                        <MonitorCard
                            title="Uso de Telas do ERP"
                            description="Acompanhe o uso das telas do sistema ERP e performance."
                            status="Ativo"
                        />
                    </Box>
                    <Box
                        onClick={() => handleNavigate('/panel/erp/comercial', 'Ativo')} 
                        cursor="pointer" 
                        _hover={{ transform: 'translateY(-2px)', shadow: 'lg' }} 
                        transition="transform 0.2s ease-in-out" 
                    >
                        <MonitorCard
                            title="Monitor Comercial"
                            description="Dashboard para acompanhamento de vendas e leads."
                            status="Ativo" 
                        />
                    </Box>
                     <Box
                        onClick={() => handleNavigate('/panel/erp/financeiro', 'Ativo')} 
                        cursor="pointer" 
                        _hover={{ transform: 'translateY(-2px)', shadow: 'lg' }} 
                        transition="transform 0.2s ease-in-out" 
                    >
                        <MonitorCard
                            title="Monitor Financeiro"
                            description="Controle com métricas de receita e despesas."
                            status="Ativo" 
                        />
                    </Box>
                </SimpleGrid>
            </Box>
        </>
    );
};

export default Home;